module.exports = __webpack_public_path__ + "img/2_132.12406b09.png";